export default {
  brewery: 'pfriemstersArtisanClub',
  info_url: 'http://landing.tavour.com/pfriemstersArtisanClub/',
  title: {
    in_progress: '',
    success: 'You Joined pFriemsters Artisan Club!',
    subtext: 'pFriemsters Artisan Club',
    sub_subtext: 'Delve into our world of award-winning finely brewed creations with the pFriemsters Artisan Club, ' +
      'designed to cater to your love of exceptional beer. Expect quarterly releases in March, June, September and December. ' +
      'Each one packed with exclusive beers, new styles, special discounts with like-minded partners and educational opportunities.',
  },
  review: {
    summary: [
      'You are joining the pFriemsters out-of-state Artisan Club. ' +
      'By signing up, your card will be charged $75.99 for 6 barrel aged bottles & ' +
      '6 cans of our newest seasonal beers, + $22 shipping 4 x per year. ' +
      'You will have the option to opt out by emailing support@tavour.com. ' +
      'You will receive notification when your box has been charged and shipped!',
    ],
    button_text: 'Join the Artisan Club!',
  },
};



// WEBPACK FOOTER //
// ./src/settings/pfriemsters_artisan_club.js